import React from 'react';
import {
    Grid,
    TextField,
    IconButton,
    Button,
    Typography,
    Box,
    Paper
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { injectIntl } from 'react-intl';

function WebhookHeadersEditor(props) {
    const { headers, onChange, intl } = props;

    const handleAddHeader = () => {
        const newHeaders = [...headers, { key: '', value: '' }];
        onChange(newHeaders);
    };

    const handleRemoveHeader = (index) => {
        const newHeaders = headers.filter((_, i) => i !== index);
        onChange(newHeaders);
    };

    const handleHeaderChange = (index, field, value) => {
        const newHeaders = [...headers];
        newHeaders[index] = { ...newHeaders[index], [field]: value };
        onChange(newHeaders);
    };

    return (
        <Paper variant="outlined" style={{ padding: 16 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="subtitle1">
                    {intl.formatMessage({ id: 'webhook.custom.headers' })}
                </Typography>
                <Button
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleAddHeader}
                    color="primary"
                >
                    {intl.formatMessage({ id: 'webhook.add.header' })}
                </Button>
            </Box>

            {headers.length === 0 ? (
                <Typography variant="body2" color="textSecondary" align="center">
                    {intl.formatMessage({ id: 'webhook.no.headers' })}
                </Typography>
            ) : (
                headers.map((header, index) => (
                    <Grid container spacing={2} key={index} style={{ marginBottom: 8 }}>
                        <Grid item xs={5}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label={intl.formatMessage({ id: 'webhook.header.name' })}
                                placeholder="X-Custom-Header"
                                value={header.key}
                                onChange={(e) => handleHeaderChange(index, 'key', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label={intl.formatMessage({ id: 'webhook.header.value' })}
                                placeholder="value"
                                value={header.value}
                                onChange={(e) => handleHeaderChange(index, 'value', e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <IconButton
                                color="error"
                                onClick={() => handleRemoveHeader(index)}
                                size="small"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))
            )}
        </Paper>
    );
}

export default injectIntl(WebhookHeadersEditor);
